import { render } from "./SpinnersContent.vue?vue&type=template&id=5d205f28"
import script from "./SpinnersContent.vue?vue&type=script&lang=js"
export * from "./SpinnersContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__